export default __webpack_public_path__ + "static/media/fogWalone.9b718215.webp";